// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '7587b8b04c7ff4d3a210db1026fb592b75c33850';
export const BUILD_NUMBER = '271';
export const BUILD_TIMESTAMP = '2026-10-21T02:40:03.587Z';
